import React, {useCallback, useContext} from 'react';
import Subshops from './Subshops.jsx';
import FilterOrderingBar from './FilterOrderingBar.jsx';
import {
    applyFilterLandmark,
    deleteFilterParams,
    getContentAjaxUrl,
    mergeSelectedFiltersWithParams,
    yieldToMain,
} from '../ArticleOverviewHelper';
import NitroEventHelper from '@core/scripts/helper/nitro-event-helper';
import Landmark from '@core/scripts/components/landmark-adapter';

import {Constants} from '../view-constants';
import {setContentAjaxCall} from '../AjaxCallSlice.jsx';
import {useDispatch, useSelector} from 'react-redux';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {selectFilterStatus} from '../FilterSlice.jsx';

function HeaderWrapper({filterContent, landmarkContent, ordering, showOnlyTokens, filledArticleList, rootShopName}) {
    const {
        contentAjaxUrl,
        prettyUrl,
        currentSearchParams,
        rootCategoryPath,
        filterRootShopId,
        shopId,
        currentUrlPath,
        currentCategoryPath,
    } = useContext(articleOverviewStaticContext);

    const isSticky = useSelector(selectFilterStatus).sticky;

    const dispatch = useDispatch();

    const filterSubmit = useCallback(
        async (clickedFilters, clickedSortOption, retainShopIdFilterOnly = false) => {
            await yieldToMain(() => {
                let mergedParams = mergeSelectedFiltersWithParams(clickedFilters, currentSearchParams.current);

                applyFilterLandmark(
                    clickedFilters,
                    mergedParams,
                    shopId.current,
                    isSticky,
                    currentSearchParams.current,
                    filterRootShopId.current,
                );
                NitroEventHelper.sendTracedEvent('FILTER_PRODUCT_LIST');

                if (clickedSortOption) {
                    mergedParams.set(Constants.SEARCH_PARAMS_ORDERING, clickedSortOption.value);
                    Landmark.sendLandmark({
                        landmark: 'userinterface',
                        click: clickedSortOption.lm,
                        fixation: isSticky ? Constants.LANDMARK_STICKY : Constants.LANDMARK_NON_STICKY,
                    });
                    NitroEventHelper.sendTracedEvent('SORT_PRODUCT_LIST');
                }

                const path =
                    clickedFilters.get(Constants.CATEGORY_FILTER_IDENTIFIER)?.path || currentCategoryPath.current;

                mergedParams.delete(Constants.SEARCH_PARAMS_PAGE);
                mergedParams.delete(Constants.SEARCH_PARAMS_ANCHOR);

                if (retainShopIdFilterOnly) {
                    mergedParams = deleteFilterParams(mergedParams);
                }

                const formattedParams = `?${mergedParams.toString()}`;

                currentUrlPath.current = currentUrlPath.current.replace(currentCategoryPath.current, path);
                currentCategoryPath.current = path;
                currentSearchParams.current = mergedParams;

                const contentAjaxCall = getContentAjaxUrl(path, formattedParams, contentAjaxUrl);
                dispatch(setContentAjaxCall([contentAjaxCall, retainShopIdFilterOnly]));
            });
        },
        [
            prettyUrl.current,
            rootCategoryPath.current,
            shopId.current,
            filterContent.shopIdFilterGroup,
            currentSearchParams.current,
            currentCategoryPath.current,
            currentUrlPath.current,
            isSticky,
        ],
    );

    return (
        <>
            {filterContent.shopIdFilterGroup && filledArticleList && (
                <Subshops
                    identifier={filterContent.shopIdFilterGroup.identifier}
                    trackingId={filterContent.shopIdFilterGroup.filters[0]?.trackingId}
                    subshops={filterContent.shopIdFilterGroup.filters[0]?.filterOptions}
                    links={filterContent.shopIdFilterGroup.links}
                    filterSubmit={filterSubmit}
                    rootShopName={rootShopName}
                />
            )}
            <FilterOrderingBar
                filterContent={filterContent}
                landmarkContent={landmarkContent}
                ordering={ordering}
                showOnlyTokens={showOnlyTokens}
                filledArticleList={filledArticleList}
                rootShopName={rootShopName}
                filterSubmit={filterSubmit}
            />
        </>
    );
}

export default React.memo(HeaderWrapper);
